module.exports = __webpack_public_path__ + "static/media/logo_graphic.57049ba4.svg";